import { render, staticRenderFns } from "./WithdrawalDifferentName.vue?vue&type=template&id=4b5827f6"
import script from "./WithdrawalDifferentName.vue?vue&type=script&lang=js"
export * from "./WithdrawalDifferentName.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalDifferentName.vue?vue&type=style&index=0&id=4b5827f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports